import { useEffect } from 'react';

const SITE = 'https://convolines.co';

function tag(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

/**
 * Sets title, description, canonical and robots for the current route. CRA ships a
 * single index.html, so without this every route inherits the homepage's meta.
 * The prerender step bakes whatever this produces into each route's static HTML.
 */
export default function useHead({ title, description, path, noindex = false }) {
  useEffect(() => {
    document.title = title;

    tag('meta[name="description"]', () => {
      const el = document.createElement('meta');
      el.setAttribute('name', 'description');
      return el;
    }).setAttribute('content', description);

    tag('link[rel="canonical"]', () => {
      const el = document.createElement('link');
      el.setAttribute('rel', 'canonical');
      return el;
    }).setAttribute('href', SITE + path);

    tag('meta[property="og:title"]', () => {
      const el = document.createElement('meta');
      el.setAttribute('property', 'og:title');
      return el;
    }).setAttribute('content', title);

    tag('meta[property="og:url"]', () => {
      const el = document.createElement('meta');
      el.setAttribute('property', 'og:url');
      return el;
    }).setAttribute('content', SITE + path);

    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      tag('meta[name="robots"]', () => {
        const el = document.createElement('meta');
        el.setAttribute('name', 'robots');
        return el;
      }).setAttribute('content', 'noindex, nofollow');
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);
}
